module.exports = __webpack_public_path__ + "img/big-number-keeping-sectors.526d6752.svg";